<script setup>
// HybsChat — interruptor para anteponer el nombre del agente en los mensajes
// salientes de WhatsApp. El backend vive en custom/app/models/custom/message.rb
// y el ajuste se guarda en account.settings.hybschat_agent_name_prefix.
//
// Archivo NUEVO sin rastrear: sobrevive a los upgrades. Lo único parcheado es
// el import + render en conversationWorkflow/index.vue.
//
// La ruta ya exige rol administrador (permissions: ['administrator']), así que
// no hace falta volver a verificarlo aquí.
import { ref, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import Switch from 'next/switch/Switch.vue';

const SETTING_KEY = 'hybschat_agent_name_prefix';

const { currentAccount, updateAccount } = useAccount();
const isEnabled = ref(false);

watch(
  currentAccount,
  account => {
    isEnabled.value = Boolean(account?.settings?.[SETTING_KEY]);
  },
  { immediate: true }
);

const toggle = async () => {
  const desired = isEnabled.value;
  try {
    await updateAccount({ [SETTING_KEY]: desired }, { silent: true });
    useAlert(
      desired
        ? 'Los mensajes de WhatsApp saldrán con el nombre del agente.'
        : 'Los mensajes de WhatsApp saldrán sin el nombre del agente.'
    );
  } catch (error) {
    isEnabled.value = !desired;
    useAlert('No se pudo guardar el cambio. Intentá nuevamente.');
  }
};
</script>

<template>
  <div
    class="flex flex-col w-full outline-1 outline outline-n-container rounded-xl bg-n-solid-2 divide-y divide-n-weak"
  >
    <div class="flex flex-col gap-2 items-start px-5 py-4">
      <div class="flex justify-between items-center w-full">
        <h3 class="text-heading-2 text-n-slate-12">
          Mostrar el nombre del agente en WhatsApp
        </h3>
        <div class="flex justify-end">
          <Switch v-model="isEnabled" @change="toggle" />
        </div>
      </div>
      <p class="mb-0 text-body-para text-n-slate-11">
        Antepone el nombre de pila del agente a cada mensaje que envía por
        WhatsApp, para que el cliente sepa quién lo está atendiendo. Solo aplica
        a agentes humanos: los mensajes del bot no se modifican.
      </p>
      <p class="mb-0 text-body-para text-n-slate-11">
        El cliente recibe:
        <span class="font-medium text-n-slate-12">*Mario:*</span>
        seguido del mensaje en la línea siguiente. En Chatwoot el agente sigue
        viendo su mensaje sin el prefijo.
      </p>
    </div>
  </div>
</template>
